export default __webpack_public_path__ + "static/media/coin.77a2fe05.png";